var map = {
	"./data_zdarzenia.svg": "d2aa",
	"./ikonka_cud.svg": "4aa5",
	"./ikonka_wypadek.svg": "91ed",
	"./ikonka_wypadek_smiertelny.svg": "be00",
	"./legenda.svg": "3f94",
	"./liczba_ofiar.svg": "a23c",
	"./liczba_rannych.svg": "d09d",
	"./lokalizacja.svg": "fc23",
	"./mjn_logo_pionowe.svg": "f0f9",
	"./mjn_logo_poziome.svg": "06a9",
	"./o_projekcie.svg": "6c55",
	"./pokaz_wszystkie_wypadki.svg": "6832",
	"./styles.scss": "2fc4",
	"./tlo_cud.jpg": "c526",
	"./tlo_mapa_cudow.jpg": "4f40",
	"./tlo_wypadek.jpg": "75c4",
	"./tlo_wypadek_smiertelny.jpg": "8602",
	"./zniszczenia.svg": "62fe"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";